export default __webpack_public_path__ + "static/media/money-back.289a68f5.png";